import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhankaianjian",
  "use": "icon-zhankaianjian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zhankaianjian\"><defs><style type=\"text/css\"></style></defs><path d=\"M204.132 700.058h665.602v89.602H204.132v-89.602z m0-469.503h665.602v90.113H204.132v-90.113z m187.907 232.96h477.695v91.649H389.992l2.047-91.649zM152.933 628.379V390.301L346.98 509.598 152.933 628.379z m0 0\" p-id=\"4458\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol